import { Box, Grid2, Typography } from "@mui/material";
import CustomModal from "components/customModal";
import React, { useState } from "react";
import Cropper from "react-easy-crop";
import BackBtn from "assets/images/backBtn.png";
import axios from "axios";
import { getUploadPublicProfile } from "api/user";
import { useUploadAvatarDone } from "hooks/user";
import "./index.scss";
import RotateImg from "assets/images/rotateImg.png";
import GradientCircularProgress from "components/GradientCircularProgress";

const CustomModalCropProfile = ({
  open,
  close,
  imagePreview,
  setOpenPictureCrop,
  setProfileStatus,
}) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [rotate, setRotate] = useState(0);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [loadingUpload, setLoadingUpload] = useState(false)
  const { mutateAsync: avatarUploadDone } = useUploadAvatarDone();

  const onCropComplete = (croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  };

  const createCroppedImageBlob = async () => {
    const canvas = document.createElement("canvas");
    const img = new Image();
    img.src = imagePreview;
    await img.decode(); // Wait for image to load
    canvas.width = croppedAreaPixels.width;
    canvas.height = croppedAreaPixels.height;
    const ctx = canvas.getContext("2d");

    // Draw the cropped area onto the canvas
    ctx.drawImage(
      img,
      croppedAreaPixels.x,
      croppedAreaPixels.y,
      croppedAreaPixels.width,
      croppedAreaPixels.height,
      0,
      0,
      croppedAreaPixels.width,
      croppedAreaPixels.height
    );

    return new Promise((resolve, reject) => {
      canvas.toBlob(
        (blob) => {
          if (blob) resolve(blob);
          else reject(new Error("Canvas is empty"));
        },
        "image/jpeg",
        1.0
      );
    });
  };

  const compressImage = async (blob) => {
    const MAX_SIZE = 2 * 1024 * 1024; // 2MB
    let quality = 0.9; // Start with high quality

    const compressBlob = async (inputBlob, currentQuality) => {
      const canvas = document.createElement("canvas");
      const img = new Image();

      const dataUrl = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.readAsDataURL(inputBlob);
      });

      img.src = dataUrl;
      await img.decode();

      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

      return new Promise((resolve, reject) => {
        canvas.toBlob(
          (blob) => {
            if (blob) resolve(blob);
            else reject(new Error("Canvas is empty"));
          },
          "image/jpeg",
          currentQuality
        );
      });
    };

    let compressedBlob = blob;

    while (compressedBlob.size > MAX_SIZE && quality > 0.1) {
      compressedBlob = await compressBlob(compressedBlob, quality);
      quality -= 0.1; // Reduce quality
    }

    if (compressedBlob.size > MAX_SIZE) {
      throw new Error("Unable to compress image to below 2MB");
    }

    return compressedBlob;
  };

  const handleCropSubmit = async () => {
    try {
      setLoadingUpload(true)
      const croppedImageBlob = await createCroppedImageBlob();
      const finalImageBlob = await compressImage(croppedImageBlob);
      const uploadUrlResponse = await getUploadPublicProfile();
      const uploadUrl = uploadUrlResponse.uploadUrl;

      await axios.put(uploadUrl, finalImageBlob, {
        headers: {
          "Content-Type": "image/jpeg",
        },
      });

      await avatarUploadDone();

      setOpenPictureCrop(false);
      setProfileStatus("bio");
      setLoadingUpload(false)
    } catch (error) {
      console.error("Error while processing the image:", error);
    }
  };

  const handleCloseModal = () => {
    setOpenPictureCrop(false);
  };

  const handleRotateNext = () => {
    setRotate((prevRotate) => prevRotate + 90);
  };

  return (
    <>
      {loadingUpload ? (
        <Box
          style={{
            height: "100%",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <GradientCircularProgress />
        </Box>
      ) : (
        <>
          <CustomModal open={open} handleClose={close}>
            <Grid2 columns={12} container className="container-cropper-modal">
              <Grid2 container columns={12} className="top-box-modal">
                <Grid2
                  item
                  size={{ xs: 2 }}
                  className="box-confirm"
                  onClick={handleCropSubmit}
                >
                  <Typography variant="h6" className="text">
                    تایید
                  </Typography>
                </Grid2>
                <Grid2 item size={{ xs: 8 }} className="box-title">
                  <Typography variant="h6" className="text">
                    ویرایش عکس پروفایل
                  </Typography>
                </Grid2>
                <Grid2
                  item
                  size={{ xs: 2 }}
                  className="box-back"
                  onClick={handleCloseModal}
                >
                  <img src={BackBtn} alt="" />
                </Grid2>
              </Grid2>

              <Box className="bottom-box">
                <Cropper
                  image={imagePreview}
                  crop={crop}
                  zoom={zoom}
                  aspect={9 / 16}
                  onCropChange={setCrop}
                  onCropComplete={onCropComplete}
                  onZoomChange={setZoom}
                  rotation={rotate}
                  style={{
                    containerStyle: {
                      width: "100%",
                      height: "85%",
                      maxWidth: "100%",
                      maxHeight: "85%",
                      borderRadius: "0px 0px 0px 0px",
                    },
                  }}
                />
              </Box>
              <Grid2 container columns={6} className="bottom-box-modal">
                <img src={RotateImg} alt="" onClick={handleRotateNext} />
              </Grid2>
            </Grid2>
          </CustomModal>
        </>
      )}
    </>
  );
};

export default CustomModalCropProfile;
